// Header Mobile Menu Toggle
function redirectJs(e) {
    e.preventDefault();
    let idp = this.getAttribute('data-idp');
    let label = this.getAttribute('data-label');
    let customUrl = this.getAttribute('data-url');
    let page = window.location.href;

    let redirectForm = document.createElement('form');
    redirectForm.target = '_blank';
    redirectForm.method = 'POST';
    redirectForm.action = '/redirect/to/';

    let redirectInput2 = document.createElement('input');
    redirectInput2.type = 'hidden';
    redirectInput2.name = 'idpage';
    redirectInput2.value = idp;
    redirectForm.appendChild(redirectInput2);

    let redirectInput3 = document.createElement('input');
    redirectInput3.type = 'hidden';
    redirectInput3.name = 'page';
    redirectInput3.value = page;
    redirectForm.appendChild(redirectInput3);

    let redirectInput4 = document.createElement('input');
    redirectInput4.type = 'hidden';
    redirectInput4.name = 'label';
    redirectInput4.value = label;
    redirectForm.appendChild(redirectInput4);

    // Добавляем custom_url если есть
    if (customUrl) {
        let redirectInput5 = document.createElement('input');
        redirectInput5.type = 'hidden';
        redirectInput5.name = 'custom_url';
        redirectInput5.value = customUrl;
        redirectForm.appendChild(redirectInput5);
    }

    document.body.appendChild(redirectForm);
    redirectForm.submit();
}

document.addEventListener("DOMContentLoaded", function() {
    let redirectButtons = document.querySelectorAll('.redirect-js');

    for (let i = 0; i < redirectButtons.length; i++) {
        redirectButtons[i].addEventListener('click', redirectJs);
    }
    const burger = document.querySelector(".header__burger");
    const nav = document.querySelector(".header__nav");
    const body = document.body;

    if (burger && nav) {
        burger.addEventListener("click", function() {
            // Toggle active classes
            burger.classList.toggle("active");
            nav.classList.toggle("active");
            body.classList.toggle("menu-open");
        });

        // Close menu when clicking on menu links
        const menuLinks = nav.querySelectorAll(".header__menu-link");
        menuLinks.forEach(link => {
            link.addEventListener("click", function() {
                burger.classList.remove("active");
                nav.classList.remove("active");
                body.classList.remove("menu-open");
            });
        });

        // Close menu on window resize if opened
        window.addEventListener("resize", function() {
            if (window.innerWidth > 768) {
                burger.classList.remove("active");
                nav.classList.remove("active");
                body.classList.remove("menu-open");
            }
        });
    }


    // Находим все таблицы внутри блока с классом text
    const tables = document.querySelectorAll('.text table');

    if(tables){
        tables.forEach(table => {
            // Проверяем, есть ли у таблицы класс no-table-wrapper
            if (!table.classList.contains('no-table-wrapper')) {
                    // Создаем внешний wrapper для скролла
                    const scrollWrapper = document.createElement('div');
                    scrollWrapper.classList.add('table-wrapper-scroll');

                    // Создаем внутренний wrapper для стилизации
                    const wrapper = document.createElement('div');
                    wrapper.classList.add('table-wrapper');

                    // Оборачиваем таблицу
                    table.parentNode.insertBefore(scrollWrapper, table);
                    scrollWrapper.appendChild(wrapper);
                    wrapper.appendChild(table);

                    // Проверяем, есть ли у таблицы элемент caption
                    if (table.querySelector('caption')) {
                            // Если caption есть, добавляем к scrollWrapper класс 'has-caption'
                            scrollWrapper.classList.add('has-caption');
                    }

                    // Получаем первую строку таблицы
                    const firstRow = table.querySelector('tr');
                    // Подсчитываем количество столбцов в первой строке
                    const columnCount = firstRow ? firstRow.children.length : 0;

                    // Если столбцов больше трех, добавляем класс 'large-table'
                    if (columnCount > 3) {
                            wrapper.classList.add('large-table');
                    }
            }
        });
    }

    // Game Tabs
    const gameTabButtons = document.querySelectorAll('.game-tabs__btn');
    if (gameTabButtons.length) {
        gameTabButtons.forEach(function(btn) {
            btn.addEventListener('click', function() {
                var tab = this.getAttribute('data-tab');
                gameTabButtons.forEach(function(b) { b.classList.remove('active'); });
                this.classList.add('active');
                document.querySelectorAll('.game-tabs__panel').forEach(function(panel) {
                    panel.classList.toggle('active', panel.getAttribute('data-panel') === tab);
                });
            });
        });
    }

    // FAQ Accordion
    const faqItems = document.querySelectorAll('.faq__item');

    if (faqItems) {
        faqItems.forEach(item => {
            const question = item.querySelector('.faq__question');
            const answer = item.querySelector('.faq__answer');

            if (question && answer) {
                question.addEventListener('click', function() {
                    // Закрываем все остальные FAQ
                    faqItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('active');
                            const otherAnswer = otherItem.querySelector('.faq__answer');
                            if (otherAnswer) {
                                otherAnswer.style.maxHeight = null;
                            }
                        }
                    });

                    // Переключаем текущий FAQ
                    item.classList.toggle('active');

                    if (item.classList.contains('active')) {
                        answer.style.maxHeight = answer.scrollHeight + 'px';
                    } else {
                        answer.style.maxHeight = null;
                    }
                });
            }
        });
    }

    // Table of Contents toggle
    const toc = document.querySelector('.toc');
    const tocHeader = document.querySelector('.toc__header');
    const tocContent = document.querySelector('.toc__content');

    if (toc && tocHeader && tocContent) {
        tocHeader.addEventListener('click', function() {
            toc.classList.toggle('active');

            if (toc.classList.contains('active')) {
                tocContent.style.maxHeight = tocContent.scrollHeight + 'px';
            } else {
                tocContent.style.maxHeight = null;
            }
        });
    }

    // Table of Contents smooth scroll
    const tocLinks = document.querySelectorAll('.toc__link');

    if (tocLinks) {
        tocLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);

                if (targetElement) {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    }

    // Contact Form Validation and Submission
    const contactForm = document.getElementById('contactForm');

    if (contactForm) {
        const submitBtn = contactForm.querySelector('.form-submit-btn');
        const nameInput = contactForm.querySelector('#name');
        const emailInput = contactForm.querySelector('#email');
        const messageInput = contactForm.querySelector('#message');

        // Изначально блокируем кнопку
        submitBtn.disabled = true;

        // Функция проверки и активации кнопки
        function checkFormValidity() {
            const formData = {
                name: nameInput.value.trim(),
                email: emailInput.value.trim(),
                message: messageInput.value.trim()
            };

            const errors = validateContactForm(formData);

            if (errors.length === 0) {
                // Форма валидна - активируем кнопку
                submitBtn.disabled = false;
                submitBtn.classList.add('active');
            } else {
                // Форма невалидна - блокируем кнопку
                submitBtn.disabled = true;
                submitBtn.classList.remove('active');
            }
        }

        // Слушаем изменения во всех полях
        nameInput.addEventListener('input', checkFormValidity);
        emailInput.addEventListener('input', checkFormValidity);
        messageInput.addEventListener('input', checkFormValidity);

        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();

            const formMessage = document.getElementById('formMessage');

            // Получаем значения полей
            const formData = {
                name: nameInput.value.trim(),
                email: emailInput.value.trim(),
                message: messageInput.value.trim()
            };

            // Валидация
            const errors = validateContactForm(formData);

            if (errors.length > 0) {
                // Показываем ошибки валидации
                showFormMessage(formMessage, errors.join('<br>'), 'error');
                console.log('Validation Errors:', errors);
                return;
            }

            // Если валидация прошла успешно
            console.log('Form validated successfully!');
            console.log('Form Data:', formData);

            // Здесь будет отправка на сервер
            // fetch('/contact-submit', { method: 'POST', body: JSON.stringify(formData) })

            // Показываем сообщение об успехе
            showFormMessage(formMessage, 'Thank you! We will contact you soon.', 'success');

            // Очищаем форму
            this.reset();

            // Блокируем кнопку после отправки
            submitBtn.disabled = true;
            submitBtn.classList.remove('active');

            // Скрываем сообщение через 5 секунд
            setTimeout(function() {
                formMessage.style.display = 'none';
            }, 5000);
        });
    }

    // Функция валидации формы
    function validateContactForm(data) {
        const errors = [];

        // Валидация имени
        if (!data.name) {
            errors.push('Please enter your name');
        } else if (data.name.length < 2) {
            errors.push('Name must be at least 2 characters');
        } else if (data.name.length > 50) {
            errors.push('Name must not exceed 50 characters');
        }

        // Валидация email
        if (!data.email) {
            errors.push('Please enter your email');
        } else if (!isValidEmail(data.email)) {
            errors.push('Please enter a valid email address');
        }

        // Валидация сообщения
        if (!data.message) {
            errors.push('Please enter your message');
        } else if (data.message.length < 10) {
            errors.push('Message must be at least 10 characters');
        } else if (data.message.length > 1000) {
            errors.push('Message must not exceed 1000 characters');
        }

        return errors;
    }

    // Функция проверки валидности email
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // Функция показа сообщения
    function showFormMessage(element, message, type) {
        element.innerHTML = message;
        element.className = 'form-message ' + type;
        element.style.display = 'block';
    }
});
